import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: Record<string, MessageDescriptor> = defineMessages({
	title: {
		id: 'rovo-reintroduction-modal.title',
		defaultMessage: 'Allow me to reintroduce myself.',
		description: 'Heading of the modal that reintroduces Rovo to the user.',
	},
	body: {
		id: 'rovo-reintroduction-modal.body',
		defaultMessage:
			'I’ve been busy learning new tricks. With 300+ new tools in Jira and Confluence, I can now take action across your entire workflow. I’ve also added deeper reasoning for complex problems, a personal memory to stay in sync with you, and the combined intelligence of Google, OpenAI, and Anthropic.',
		description: 'Body copy describing the new Rovo capabilities.',
	},
	primaryAction: {
		id: 'rovo-reintroduction-modal.primary-action',
		defaultMessage: 'Tell me how to improve my workflow with Rovo',
		description: 'Label for the primary call to action that opens Rovo chat.',
	},
	chatPreviewPrompt: {
		id: 'rovo-reintroduction-modal.chat-preview-prompt',
		defaultMessage: 'What do you want to do next?',
		description: 'Placeholder text shown in the decorative chat input preview.',
	},
});
